"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ExpandLessIcon_1 = __importDefault(require("@portalterreno/react-ui-icons/ExpandLessIcon"));
const ExpandMoreIcon_1 = __importDefault(require("@portalterreno/react-ui-icons/ExpandMoreIcon"));
const react_1 = require("react");
const hooks_1 = require("../hooks");
const Label_1 = __importDefault(require("../Label"));
const Control_1 = __importDefault(require("./Control"));
const Placeholder_1 = __importDefault(require("./Placeholder"));
const Wrapper_1 = __importDefault(require("./Wrapper"));
function Select({ children, closedIcon = ((0, jsx_runtime_1.jsx)(ExpandMoreIcon_1.default, { fontSize: 'large', color: 'inherit' })), defaultIsOpen = false, onSelectValue, openedIcon = ((0, jsx_runtime_1.jsx)(ExpandLessIcon_1.default, { fontSize: 'large', color: 'inherit' })), placeholder, renderValue, value, wrapperComponent: WrapperComponent = Wrapper_1.default, label, disabled = false, hasError = false, ...rest }) {
    const [isOptionsOpen, setIsOptionsOpen] = (0, react_1.useState)(defaultIsOpen);
    const toggleOptions = (0, react_1.useCallback)(() => {
        if (!disabled) {
            setIsOptionsOpen((previousState) => !previousState);
        }
    }, [disabled]);
    const renderedValue = (0, react_1.useMemo)(() => {
        if (renderValue && value) {
            return renderValue(value);
        }
        if (value &&
            ((0, react_1.isValidElement)(value) ||
                typeof value === 'string' ||
                typeof value === 'number' ||
                typeof value === 'boolean')) {
            return (0, jsx_runtime_1.jsx)(react_1.Fragment, { children: value });
        }
        return undefined;
    }, [value, renderValue]);
    const renderedPlaceholder = (0, react_1.useMemo)(() => {
        if (!(0, react_1.isValidElement)(placeholder)) {
            return (0, jsx_runtime_1.jsx)(Placeholder_1.default, { children: placeholder });
        }
        return placeholder;
    }, [placeholder]);
    const wrapperRef = (0, react_1.useRef)(null);
    (0, hooks_1.useClickOutside)(wrapperRef, (0, react_1.useCallback)(() => setIsOptionsOpen(false), []));
    const renderedLabel = (0, react_1.useMemo)(() => {
        if ((0, react_1.isValidElement)(label) || !label) {
            return label;
        }
        return (0, jsx_runtime_1.jsx)(Label_1.default, { variant: hasError ? 'error' : undefined, children: label });
    }, [label, hasError]);
    return ((0, jsx_runtime_1.jsxs)(WrapperComponent, { onClick: toggleOptions, ref: wrapperRef, children: [renderedLabel, (0, jsx_runtime_1.jsxs)(Control_1.default, { ...rest, isOpen: isOptionsOpen, disabled: disabled, hasError: hasError, children: [renderedValue || (placeholder && renderedPlaceholder), isOptionsOpen ? openedIcon : closedIcon] }), isOptionsOpen &&
                (0, react_1.cloneElement)(children, {
                    onSelectValue,
                    value
                })] }));
}
exports.default = Select;
//# sourceMappingURL=Select.js.map